const DropDownConfig = {
  //general
  generalLineOfBusiness: "LI_OF_015",
  generalProduct: "GE_CA_017",
  generalSubProduct: "SUB_PR",            //to be changed
  generalPolicyType: "MO_PO_TY_004",
  generalCoverageType: "MO_CO_TY_014",
  generalVehicleCategory: "VEH_CAT",         //to be changed
  motorCategory: "MO_CA_021",            

  //motor
  motorFuelType: "FU_TY_003",
  motorRTOZone: "RT_ZO_013",
  motorRTORegion: "RT_RE_014",

  //insurer
  insurerFuelType: "IN_FU_TY_003",   
  insurerRtoRegion: "IN_RT_ZO_013",
  insurerRtoZone: "IN_RT_RE_014",  
  
  //api integration engine
  apiApiEndpoint: "API_END",        //to be changed
  apiEnvironment: "EN_002",
  apiWidgetType: "WI_TY_004",
  apiDataType: "DA_TY_003",
  apiFieldCategory: "FI_CA_005",
  apiApiCategory: "AP_CA_006",
  apiSchemaType: "SC_TY_008",
  apiCompatibilityMode: "CO_MO_009",
  apiStatus: "AP_ST_011",
  apiProtocol: "AP_PR_012",
  apiAuthType: "AU_TY_013",
  apiHttpMethod: "HT_ME_014",
  apiGraphQLOperationType: "GR_OP_TY_015",
  apiDataDirection: "DA_DI_007",

  //operation
  operationBindingType: "WO_BI_TY_004",
  operationBinding: "BIN",                  //to be changed
  operationFieldCategory: "FIE_CAT",        //to be changed
  operationWorkflowStepType: "WO_ST_TY_002",     
  operationWorkflowCategory: "WO_CA_001",
};

export default DropDownConfig;
